import PropTypes from 'prop-types';

// Libs
import { useTranslation } from 'next-i18next';

// Utils
import { cn } from 'utils';

// Hooks
import useResponsiveQueries from '../../../src/hooks/useResponsiveQueries';

import styles from './InputWrapper.module.css';

function InputWrapper({
  label, className, inputClassName, maxWidth, required, error, children, disabled, color,
}) {
  const { t } = useTranslation();
  const { isMobile } = useResponsiveQueries();

  return (
    <div
      className={cn(['padding-top-8', className || '', styles[color]])}
      style={isMobile ? {} : { maxWidth }}
    >
      <div
        className={cn([
          styles.input,
          error ? styles.with_error : '',
          inputClassName || '',
          disabled ? styles.disabled : '',
        ])}
      >
        {children}

        {label ? (
          <div className={styles.field_top}>
            <span className={cn([styles.label_wrapper, 'd-flex a-center'])}>
              <span className={styles.label}>{label}</span>
              {required ? (
                <span className={styles.required}>*</span>
              ) : null}
            </span>
          </div>
        ) : (
          <div className={styles.no_label} />
        )}
      </div>

      {error ? (
        <p className="p2-desktop-default font-color-red margin-top-8 p2-mobile-default">
          {t(error)}
        </p>
      ) : null}
    </div>
  );
}

InputWrapper.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  maxWidth: PropTypes.number,
  required: PropTypes.bool,
  error: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  color: PropTypes.oneOf(['black', 'white', 'dark', 'light', '']),
};

InputWrapper.defaultProps = {
  label: null,
  className: null,
  inputClassName: null,
  maxWidth: null,
  required: false,
  error: null,
  disabled: false,
  color: 'white',
};

export default InputWrapper;
